import React from "react";
import "./About.css";
import aboutVid from "../../assets/about.mp4";

const About = () => {
  return (
    <div className="About">
      <h3>About Us</h3>
      <div className="about-cont">
        <p>
          Ubeka AI is an intelligent skincare assistant designed specifically
          for melanin-rich (African and Black) skin. Using artificial
          intelligence, the app analyzes a user’s face through a selfie to
          detect skin conditions such as acne, dark spots, pimples, hyperpigmentation, dryness, and
          uneven tones and texture—issues that often present differently in darker skin
          tones. It then provides personalized skincare product recommendations
          and routines tailored to the unique needs of melanin-rich skin. By
          combining computer vision, machine learning, and a curated database of
          suitable products, Ubeka AI removes the guesswork from
          skincare—helping users avoid ineffective or harmful products, save
          money, and achieve healthier skin faster. Ubeka AI acts as a trusted
          digital beauty advisor, built to serve a market that has long been
          underserved and overlooked by traditional skincare solutions.
        </p>
        <div className="about-vid">
          <video src={aboutVid} controls autoPlay={true}></video>
        </div>
      </div>
    </div>
  );
};

export default About;
